<template>
  <div class="flex flex-col gap-4 items-center text-white">
    <span class="loading loading-spinner w-20 text-brand-primary" />
    <p class="text-base uppercase">
      {{ $t("channel.purchase.waiting.title") }}
    </p>
    <p class="text-sm text-basics-secondary-80">
      {{ $t("channel.purchase.waiting.loading") }}
    </p>
  </div>
</template>

<script setup lang="ts">
const _emit = defineEmits<{
  cancel: [];
}>();
</script>
